import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Renders the Ultmarc remark label with an optional note line.
 * Extracted from repeated usage across multiple pages.
 */
const UltmarcRemarkLabel = () => {
  const [lang] = useTranslation("language");

  return (
    <>
      {lang("organizationDetails.ultmarcRemark")}
      {lang("organizationDetails.ultmarcRemarkNote") && (
        <>
          <br />
          <span className="ultmarc-contact-note">
            {lang("organizationDetails.ultmarcRemarkNote")}
          </span>
        </>
      )}
    </>
  );
};

export default UltmarcRemarkLabel;
